import classNames from 'classnames';

export const Pastille = ({ className }: { className?: string }) => {
  const customClassName = classNames(
    'bg-color-pone-orange h-[4px] w-[4px] rounded-full',
    className,
  );
  return <div className={customClassName} />;
};
